module.exports = __webpack_public_path__ + "img/more.8bd2fbad.png";